import { useState } from "react"
import TextField from "~/components/TextField/TextField"
import IconSearch from "../Icons/IconSearch"
import "./SearchField.scss"

type SearchFieldProps = {
  onChange?: (value: string) => void
  style?: "light" | "dark"
}

function SearchField({ style = "light", onChange }: SearchFieldProps) {
  const [active, setActive] = useState(false)
  const [value, setValue] = useState("")

  const handleChange = (value: string) => {
    setValue(value)
    onChange?.(value)
  }

  return (
    <div className="SearchField">
      {active ? (
        <TextField
          style={style}
          value={value}
          autofocus={true}
          placeholder="Search..."
          valueChanged={(value) => {
            handleChange(value)
          }}
        />
      ) : (
        <button
          className={`SearchField__button ${style}`}
          onClick={() => setActive(true)}
        >
          <IconSearch />
        </button>
      )}
    </div>
  )
}

export default SearchField
